<script setup>
import { useQuasar } from 'quasar'
import useDevice from '../../../store/device.store'
import DeviceUpdate from './Update.vue'
import DeviceCreate from './Create.vue'
import { callApi, formatTime } from '../../../utils'
import apiDevice from '../../../api/device.api'
import Table from '../../shared/Table.vue'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const {
  deviceList,
  getDeviceList,
  loading,
  pagination,
  filterOptions
} = useDevice()

const $q = useQuasar()

const columns = [
  { name: 'name', align: 'left', label: t("device.name"), field: 'name' },
  { name: 'deviceNumber', align: 'left', label: t("device.number"), field: 'deviceNumber' },
  { name: 'deviceId', align: 'left', label: t("device.id"), field: 'deviceId' },
  { name: 'createdAt', align: 'left', label: t("table.columns.createdAt"), field: 'createdAt', format: v => formatTime(v) },
  { name: 'createdBy', align: 'left', label: t("table.columns.createdBy"), field: v => v.createdBy && v.createdBy.name ? v.createdBy.name : '' },
]

function paginate(props) {
  callApi([getDeviceList], {
    ...filterOptions.value,
    page: parseInt(props.pagination.page),
    "page-size": parseInt(props.pagination.rowsPerPage)
  }, $q, loading)
}

function showUpdate(_, row) {
  $q.dialog({
    component: DeviceUpdate,
    componentProps: {
      id: row._id,
      fetch: fetch
    }
  })
}

function createDevice() {
  $q.dialog({
    component: DeviceCreate
  })
}

function openDevice(id) {
  $q.dialog({
    title: t("device.control.open.title"),
    message: t("device.control.open.desc"),
    ok: t("actions.ok"),
    cancel: t("actions.cancel"),
    transitionShow: 'fade',
    transitionHide: 'fade'
  }).onOk(() => {
    callApi([apiDevice.open], id, $q, loading)
  })
}

function closeDevice(id) {
  $q.dialog({
    title: t("device.control.close.title"),
    message: t("device.control.close.desc"),
    ok: t("actions.ok"),
    cancel: t("actions.cancel"),
    transitionShow: 'fade',
    transitionHide: 'fade'
  }).onOk(() => {
    callApi([apiDevice.close], id, $q, loading)
  })
}

function resetDevice(id) {
  $q.dialog({
    title: t("device.control.reset.title"),
    message: t("device.control.reset.desc"),
    ok: t("actions.ok"),
    cancel: t("actions.cancel"),
    transitionShow: 'fade',
    transitionHide: 'fade'
  }).onOk(() => {
    callApi([apiDevice.resetDeviceState], id, $q, loading)
  })
}
function fetch() {
  callApi([getDeviceList], {
    'page-size': parseInt(pagination.value.rowsPerPage)
  }, $q, loading)
}

fetch()
console.log("Device list: ", deviceList)
</script>

<template lang='pug'>
.device-list
  Table(
    :title='t("menu.devices")'
    :rows='deviceList'
    :loading='loading'
    :columns='columns'
    row-key='_id'
    v-model:pagination="pagination"
    @request="paginate"
    @row-click='showUpdate'
  )
    template(v-slot:header='props')
      q-th(v-for="(col, index) in props.cols" :key="col.name")
        div {{ col.label }}
      q-th
        div {{ t("device.control.title") }}
    
    template(v-slot:body="props")
      q-td(v-for="col in props.cols" :key="col.name"  @click="showUpdate(props, props.row)")
        div {{ col.value }}
      q-td
        q-btn(
          size='sm'
          icon='lock_open'
          push
          round
          tooltip="Open Device"
          @click.stop='openDevice(props.row._id)'
          class="q-mr-sm"
        )
        q-btn(
          size='sm'
          icon='lock'
          push
          round
          tooltip="Close Device"
          @click.stop='closeDevice(props.row._id)'
          class="q-mr-sm"
        )
        q-btn(
          size='sm'
          icon='refresh'
          push
          round
          tooltip="Reset Device State"
          @click.stop='resetDevice(props.row._id)'
          class="q-mr-sm"
        )
</template>
